// extracted by mini-css-extract-plugin
export var buttons = "support-contact-panel-module--buttons--cfe3d";
export var closeButton = "support-contact-panel-module--closeButton--4ff5d";
export var col = "support-contact-panel-module--col--85e77";
export var confirmationContainer = "support-contact-panel-module--confirmationContainer--dbd26";
export var contact = "support-contact-panel-module--contact--c57e8";
export var contactAndHoursPanel = "support-contact-panel-module--contactAndHoursPanel--53ebf";
export var ctaa = "support-contact-panel-module--ctaa--5a1ce";
export var customFileUpload = "support-contact-panel-module--customFileUpload--09500";
export var disclaimer = "support-contact-panel-module--disclaimer--cb9a9";
export var errorMsg = "support-contact-panel-module--errorMsg--15454";
export var fileName = "support-contact-panel-module--fileName--bebe6";
export var filesContainer = "support-contact-panel-module--filesContainer--7e965";
export var form = "support-contact-panel-module--form--57580";
export var formPanel = "support-contact-panel-module--formPanel--abbe2";
export var formSbmitDescription = "support-contact-panel-module--formSbmitDescription--01251";
export var formSubmitHeadline = "support-contact-panel-module--formSubmitHeadline--8047e";
export var headline = "support-contact-panel-module--headline--3a7f1";
export var honeyPotInputField = "support-contact-panel-module--honeyPotInputField--3f5c7";
export var imageBtnWithLabel = "support-contact-panel-module--imageBtnWithLabel--d20f3";
export var innerContent = "support-contact-panel-module--innerContent--a873a";
export var iosspecfs = "support-contact-panel-module--iosspecfs--6f0c8";
export var jotFormPanel = "support-contact-panel-module--jotFormPanel--937f8";
export var messageField = "support-contact-panel-module--messageField--f18bf";
export var prodLine = "support-contact-panel-module--prodLine--27b66";
export var subHeadingContainer = "support-contact-panel-module--subHeadingContainer--a2cae";
export var subheading = "support-contact-panel-module--subheading--9b783";
export var wrapper = "support-contact-panel-module--wrapper--8beda";